module.exports = __webpack_public_path__ + "img/close.26be40a0.svg";